/**
 * SharepointConfiguration domain entity.
 * Represents Microsoft SharePoint integration configuration for secure document storage.
 */
export class SharepointConfigurationEntity {
  public sharepointConfigurationId!: number;
  public sharepointTenantId!: string;
  public clientId!: string;
  public clientSecret!: string;
  public baseUrl!: string;
  public automaticFolderCreation!: boolean;
  public tenantId!: number;
  public isDeleted!: boolean;
  public createdOn!: string;
  public updatedOn!: string;
}
